import { Link } from "react-router-dom";

const shortcuts = [
  { icon: "ri-film-line", label: "电影", path: "/category?type=电影" },
  { icon: "ri-tv-2-line", label: "电视剧", path: "/category?type=电视剧" },
  { icon: "ri-rocket-2-line", label: "科幻", path: "/category?genre=科幻" },
  { icon: "ri-search-eye-line", label: "悬疑", path: "/category?genre=悬疑" },
  { icon: "ri-heart-3-line", label: "爱情", path: "/category?genre=爱情" },
  { icon: "ri-sword-line", label: "古装", path: "/category?genre=古装" },
  { icon: "ri-global-line", label: "欧美", path: "/category?region=美国" },
  { icon: "ri-earth-line", label: "华语", path: "/category?region=中国大陆" },
];

export default function CategoryShortcuts() {
  return (
    <div className="w-full px-4 md:px-8 -mt-10 relative z-20">
      <div className="w-full rounded-lg bg-background-50 border border-background-200 p-4 md:p-6">
        <div className="grid grid-cols-4 md:grid-cols-8 gap-3 md:gap-4">
          {shortcuts.map((item) => (
            <Link
              key={item.label}
              to={item.path}
              className="flex flex-col items-center gap-2 py-2 rounded-md hover:bg-primary-50 transition-colors cursor-pointer group"
            >
              <span className="w-12 h-12 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-accent-100 group-hover:text-accent-700 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-600">{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}